import apiHelper from "./apiHelper"
import { API_ROUTES } from "../utils/constants"

export function createTsServer(data) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.CREATE_SERVER, data: data })
}

export function editTsServer(data) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.EDIT_SERVER, data: data })
}

export function extendServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.EXTEND_SERVER, data: { serverId } })
}

export function startTsServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.START_SERVER, data: { serverId } })
}

export function stopTsServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.STOP_SERVER, data: { serverId } })
}

export function restartTsServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.RESTART_SERVER, data: { serverId } })
}

export function activateTsServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.ACTIVATE_SERVER, data: { serverId } })
}

export function suspendTsServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.SUSPEND_SERVER, data: { serverId } })
}

export function deleteTsServer(serverId) {
    return apiHelper({ method: "delete", path: API_ROUTES.SERVER.DELETE_SERVER, data: { serverId } })
}

export function startAllTsServers(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.START_SERVER_BULK, data: { selecteds } })
}

export function stopAllTsServers(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.STOP_SERVER_BULK, data: { selecteds } })
}
export function restartAllTsServers(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.RESTART_SERVER_BULK, data: { selecteds } })
}

export function getServer(serverId) {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.GET_SERVER, data: { serverId } })
}

export function getUsedPorts() {
    return apiHelper({ method: "post", path: API_ROUTES.SERVER.GET_USED_PORTS })
}
